var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09864 8.31901e-06C8.64326 0.0021134 9.95947 1.21505 10.4404 2.90333L10.4619 2.9004L10.6397 2.89259C11.9446 2.8968 13.0017 4.19162 13 5.78516C12.9981 7.30677 12.0313 8.55059 10.8076 8.65821L10.6328 8.667L2.35841 8.64942C1.05352 8.64521 -0.00326131 7.35329 7.56311e-06 5.75782C0.00173147 4.16427 1.0622 2.87388 2.3672 2.87598C2.83583 2.87815 3.27359 3.04584 3.64063 3.33399C4.00964 1.42083 5.41813 -0.00397204 7.09864 8.31901e-06ZM6.23731 2.01759V4.10645H4.14845V5.33302H6.23731V7.42188H7.46387V5.33302H9.55274V4.10645H7.46387V2.01759H6.23731Z",
    fill: "#C5D2DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSf);
export default __webpack_public_path__ + "static/media/SF.41e9261feda337fa628b2d0d2cf5a40a.svg";
export { ForwardRef as ReactComponent };